/* eslint-disable no-console */
import {
    Configuration,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';
import { repairSmithFieldOps } from 'utilities/getRepairSmithFieldOps';

let msalSingleton: PublicClientApplication | null = null;

export function isAzureSsoConfigured(): boolean {
  return Boolean(
    repairSmithFieldOps.AZURE_AD_CLIENT_ID &&
      repairSmithFieldOps.AZURE_AD_TENANT_ID
  );
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

export const apiRequest = {
  scopes: [`api://${repairSmithFieldOps.AZURE_ISP_CLIENT_ID}/access_as_user`],
};

export function parseAzureAdScopes(): string[] {
  const raw =
    (repairSmithFieldOps.AZURE_AD_SCOPES as string) ||
    'email profile openid offline_access';
  return raw.split(/[\s,]+/).filter(Boolean);
}

export function getMsalInstance(): PublicClientApplication | null {
  if (!isAzureSsoConfigured()) return null;
  if (msalSingleton) return msalSingleton;

  const clientId = repairSmithFieldOps.AZURE_AD_CLIENT_ID as string;
  const tenantId = repairSmithFieldOps.AZURE_AD_TENANT_ID as string;
  const redirectUri =
    (repairSmithFieldOps.AZURE_AD_REDIRECT_URI as string) ||
    `${window.location.origin}/auth`;

  const configuration: Configuration = {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
    },
    cache: { cacheLocation: 'localStorage' },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Verbose,
        loggerCallback: (level, message) => {
          console.log(`[msal:${LogLevel[level]}]`, message);
        },
      },
    },
  };

  msalSingleton = new PublicClientApplication(configuration);
  return msalSingleton;
}
